import { Link } from "react-router-dom";
import { categorySlug, formatDate } from "@/lib/api";
import { resizeImage } from "@/lib/img";

export function ArticleCard({ article, size = "md", showExcerpt = true, displayCategory }) {
  const sizeClasses = {
    sm: { img: "aspect-[4/3]", title: "text-base sm:text-lg", preset: "thumb" },
    md: { img: "aspect-[4/3]", title: "text-lg sm:text-xl md:text-2xl", preset: "card" },
    lg: { img: "aspect-[16/10]", title: "text-2xl sm:text-3xl md:text-4xl", preset: "hero" },
    xl: { img: "aspect-[16/10]", title: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl", preset: "hero" },
  };
  const cls = sizeClasses[size] || sizeClasses.md;
  const cat = displayCategory || article.category;

  return (
    <Link
      to={`/article/${article.slug}`}
      className="article-card block group"
      data-testid={`article-card-${article.slug}`}
    >
      <div className={`zoom-img ${cls.img} bg-neutral-100 relative`}>
        <img
          src={resizeImage(article.cover_image, cls.preset)}
          alt={article.title}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.opacity = "0.4"; }}
        />
        <div className="absolute top-3 left-3">
          <span className="bg-white/95 text-black text-[10px] uppercase tracking-[0.22em] font-bold px-2 py-1">
            {cat}
          </span>
        </div>
      </div>
      <div className="pt-4">
        <div className="overline text-neutral-500 mb-2">
          <span className="text-neutral-700">{cat}</span>
          <span className="mx-2">·</span>
          <span>{formatDate(article.created_at)}</span>
        </div>
        <h3 className={`article-title font-serif-ed font-semibold leading-tight tracking-tight transition-colors ${cls.title}`}>
          {article.title}
        </h3>
        {showExcerpt && article.excerpt && size !== "sm" && (
          <p className="mt-3 text-sm sm:text-base text-neutral-600 leading-relaxed line-clamp-3">
            {article.excerpt}
          </p>
        )}
        {article.author && article.author !== "Hinton Editorial" && (
          <div className="mt-3 text-[11px] font-mono-ed uppercase tracking-[0.2em] text-neutral-500">
            By {article.author}
          </div>
        )}
      </div>
    </Link>
  );
}

export function ArticleRow({ article, displayCategory }) {
  const cat = displayCategory || article.category;
  return (
    <Link
      to={`/article/${article.slug}`}
      className="article-card grid grid-cols-12 gap-4 py-5 border-b border-neutral-200 group"
      data-testid={`article-row-${article.slug}`}
    >
      <div className="col-span-4 sm:col-span-3 zoom-img aspect-[4/3] bg-neutral-100">
        <img src={resizeImage(article.cover_image, "thumb")} alt={article.title} loading="lazy" decoding="async" className="w-full h-full object-cover" />
      </div>
      <div className="col-span-8 sm:col-span-9">
        <div className="overline text-neutral-500 mb-2">
          {cat} · {formatDate(article.created_at)}
        </div>
        <h3 className="article-title font-serif-ed font-semibold text-lg sm:text-xl md:text-2xl leading-tight tracking-tight transition-colors">
          {article.title}
        </h3>
        <p className="hidden sm:block mt-2 text-sm text-neutral-600 line-clamp-2">{article.excerpt}</p>
      </div>
    </Link>
  );
}
